<template>

    <!-- 本地 SVG 图标 -->
    <svg
      v-if="isLocalIcon"
      :class="svgClass"
      :aria-hidden="true"
      v-bind="$attrs"
      :style="{ fontSize: size, color: color, width: computedWidth, height: computedWidth }"
    >
      <use :xlink:href="iconName" :fill="color" />
    </svg>
    <!-- Ant Design 图标 -->
    <component
      v-else-if="antdComponent"
      :is="antdComponent"
      v-bind="$attrs"
      :style="{
        color: color,
        fontSize: computedWidth,
        width: computedWidth,
        height: computedWidth,
      }"
      :class="className"
    />
    <template v-else>
      <svg v-if="iconName"
      v-bind="$attrs"
        :class="svgClass" :aria-hidden="true" :style="{ color: color, width:
        computedWidth, height: computedWidth }" >
        <use :xlink:href="iconName" :fill="color" />
      </svg>
      <!-- 无效图标回退 -->
      <span
        v-else
        :style="{ color: color, fontSize: computedWidth }"
        class="svg-icon-fallback"
        v-bind="$attrs"
        >{{ iconName }}</span
      >
    </template>
</template>

<script setup>
import { defineProps, computed } from 'vue'
import * as antIcons from '@ant-design/icons-vue'

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  color: {
    type: String,
    default: '',
  },
  size: {
    type: Number,
  },
  className: {
    type: String,
    default: '',
  },
})

// 判断是否为本地图标（以 local- 开头）
const isLocalIcon = computed(() => props.name?.startsWith('local-'))

// 本地图标的 use 引用 ID
const iconName = computed(() => {
  if (isLocalIcon.value) {
    const pureName = props.name.replace(/^local-/, '')
    return `#icon-${pureName}`
  } else if (!antIcons[props.name]) {
    return `#icon-${props.name}`
  }
  return ''
})

// 获取 Ant Design 图标组件（如果不是本地图标）
const antdComponent = computed(() => {
  if (!isLocalIcon.value && props.name) {
    return antIcons[props.name] || null
  }
  return null
})

// 计算尺寸（兼容原有的 size 和 width 属性）
const computedWidth = computed(() => {
  const result = props.width || props.size
  return result ? result + 'px' : '1em'
})

// SVG 的 class（保留原有逻辑）
const svgClass = computed(() => {
  if (props.name && isLocalIcon.value) {
    const pureName = props.name.replace(/^local-/, '')
    return `svg-icon icon-${pureName} ${props.className}`
  }
  return 'svg-icon ' + props.className
})
</script>

<style lang="scss" scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  fill: currentColor;
  vertical-align: middle;
}
.svg-icon-fallback {
  display: inline-block;
  width: 1em;
  text-align: center;
}
</style>
